const reduceClearLockError = (state) => ({ ...state, lockError: false });

// noinspection JSUnusedGlobalSymbols
export default reduceClearLockError;
